import './addDonateButton.scss';

import React, { FunctionComponent } from 'react';

import { DonateButtonFormData } from '../../../types/givingCheckoutForm';
import { DonateButtonProps } from './DonateButtonTypes';
import JustGivingButton from './JustGivingButton/JustGivingButton';
import JustGivingButtonPreview from './JustGivingButton/JustGivingButtonPreview';
import OwnButton from './OwnButton';
import StandardButton from './StandardButton/StandardButton';
import StandardButtonPreview from './StandardButton/StandardButtonPreview';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const AddDonateButton: FunctionComponent<DonateButtonProps> = ({
  codeBlockType,
  linkId,
  isDefault,
}) => {
  const { t } = useTranslation();

  const { watch, register } = useFormContext<DonateButtonFormData>();
  const buttonType = watch('buttonType');

  return (
    <>
      <fieldset className="jg-form-group">
        <legend className="jg-form-label jg-space-mbxs jg-color--empress">
          <p>{t('donateButton.buttonTypeSubText1')}</p>
          <p>{t('donateButton.buttonTypeSubText2')}</p>
        </legend>
        <input
          className="jg-radio"
          type="radio"
          id="buttonType-standard"
          value="standard"
          {...register('buttonType')}
        />
        <label className="jg-form-label" htmlFor="buttonType-standard">
          {t('donateButton.buttonTypeStandard')}
        </label>
        <input
          className="jg-radio"
          type="radio"
          id="buttonType-justgiving"
          value="justgiving"
          {...register('buttonType')}
        />
        <label className="jg-form-label" htmlFor="buttonType-justgiving">
          {t('donateButton.buttonTypeJustgiving')}
        </label>
        <input
          className="jg-radio"
          type="radio"
          id="buttonType-own"
          value="own"
          {...register('buttonType')}
        />
        <label className="jg-form-label" htmlFor="buttonType-own">
          {t('donateButton.buttonTypeOwn')}
        </label>
      </fieldset>
      {buttonType === 'justgiving' && <JustGivingButtonPreview />}
      {buttonType === 'standard' && <StandardButtonPreview />}
      {['justgiving', 'standard'].includes(buttonType) && (
        <fieldset className="jg-form-group">
          <input
            type="checkbox"
            className="jg-checkbox"
            id="includePaymentLogos"
            {...register('includePaymentLogos')}
          />
          <label htmlFor="includePaymentLogos" className="jg-form-label">
            {t('donateButton.paymentLogosLabel')}
          </label>
        </fieldset>
      )}
      {buttonType === 'justgiving' && (
        <JustGivingButton
          codeBlockType={codeBlockType}
          linkId={linkId}
          isDefault={isDefault}
        />
      )}
      {buttonType === 'standard' && (
        <StandardButton
          codeBlockType={codeBlockType}
          linkId={linkId}
          isDefault={isDefault}
        />
      )}
      {buttonType === 'own' && (
        <OwnButton isDefault={isDefault} linkId={linkId} />
      )}
    </>
  );
};

export default AddDonateButton;
